module.exports = __webpack_public_path__ + "h5/img/live-logo.38fb48a2.gif";